import React from "react";
import PropTypes from "prop-types";
import "./index.less";

const Button = props => {
  return <div className="weax-button" onClick={props.onClick} onMouseOver={props.onMouseOver}>{props.value}</div>;
};

Button.defaultProps = {
  value: "Button",
  onClick: (e) => { console.log(e) },
  onMouseOver: (e) => { console.log(e) }
};

Button.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
};

export default Button;
